import React, { ReactElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { LinkButton } from '@alycecom/ui';

const useStyles = makeStyles(({ spacing }) => ({
  button: {
    marginLeft: spacing(1),
  },
  mobileFont: {
    '@media (max-width:440px)': {
      fontSize: '12px !important',
    },
  },
  submitButton: {
    width: 275,
  },
}));

export type ReSubscribeLinkProps = {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

const ReSubscribeLink = ({ onClick }: ReSubscribeLinkProps): ReactElement => {
  const classes = useStyles();
  return (
    <Box mt={1} display="flex" flexDirection="row" justifyContent="flex-start" alignItems="center">
      <Typography
        data-testid="resubscribeQuestion"
        className={classNames('Body-Regular-Left-Inactive', classes.mobileFont)}
      >
        Wanna think about it twice?
      </Typography>
      <LinkButton
        data-testid="resubscribeLink"
        onClick={onClick}
        className={classNames(classes.button, classes.mobileFont)}
      >
        Click here to re-subscribe
      </LinkButton>
    </Box>
  );
};

ReSubscribeLink.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ReSubscribeLink;
